import {type ReactNode, useEffect} from "react";

import {Button, IButtonSizePrimary} from "@pg-design/button-module";
import {PhoneIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";

import {useApplicationPhoneClipNumber} from "../application/hooks/use_application_phone_clip_number";
import {PhoneButton} from "./PhoneButton";

interface IProps {
    fallbackNumber?: string | null;
    onShowPhoneNumber?: () => void;
    onClickPhoneNumber?: () => void;
    text?: string;
    propertyId?: number;
    className?: string;
    customPhoneButton?: (onClick: () => void, phoneNumber: string) => ReactNode;
    fetchOnMount?: boolean;
    useHotlineNumber?: boolean;
    buttonSize?: IButtonSizePrimary;
    buttonStyleOverride?: string;
}

const NO_CONTACT_DATA = "BRAK DANYCH KONTAKTOWYCH";

export const ClipPhoneButton = (props: IProps) => {
    const {
        buttonSize,
        buttonStyleOverride,
        fallbackNumber,
        onShowPhoneNumber,
        onClickPhoneNumber,
        text = "Pokaż numer",
        propertyId,
        className,
        customPhoneButton,
        fetchOnMount,
        useHotlineNumber
    } = props;
    const {phoneNumber, fetchClipPhoneNumber, isFetching, isUninitialized, isClipPhoneBlocked} = useApplicationPhoneClipNumber(
        fallbackNumber,
        useHotlineNumber
    );

    useEffect(() => {
        if (fetchOnMount && isUninitialized) {
            fetchClipPhoneNumber(propertyId);
            onShowPhoneNumber?.();
        }
    }, [fetchOnMount]);

    const onClick = () => {
        fetchClipPhoneNumber(propertyId);
        onShowPhoneNumber?.();
    };

    const handleClickPhoneNumber = () => {
        onClickPhoneNumber?.();
    };

    if (isFetching) {
        return (
            <div className={className}>
                <Loader size="sm" />
            </div>
        );
    }

    if (phoneNumber) {
        return (
            customPhoneButton?.(handleClickPhoneNumber, phoneNumber) || (
                <PhoneButton phoneNumber={phoneNumber} onClickPhoneNumber={handleClickPhoneNumber} className={className} />
            )
        );
    }

    if ((!isUninitialized && !phoneNumber) || isClipPhoneBlocked) {
        return (
            <Text as="span" variant="headline_6" align="center" color="var(--colors-secondary)" className={className}>
                {NO_CONTACT_DATA}
            </Text>
        );
    }

    return (
        <div className={className}>
            <Button onClick={onClick} iconLeft={PhoneIcon} type="button" variant="outlined_secondary" size={buttonSize} className={buttonStyleOverride}>
                {text}
            </Button>
        </div>
    );
};
import {type ReactNode, useEffect} from "react";

import {Button, IButtonSizePrimary} from "@pg-design/button-module";
import {PhoneIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";

import {useApplicationPhoneClipNumber} from "../application/hooks/use_application_phone_clip_number";
import {PhoneButton} from "./PhoneButton";

interface IProps {
    fallbackNumber?: string | null;
    onShowPhoneNumber?: () => void;
    onClickPhoneNumber?: () => void;
    text?: string;
    propertyId?: number;
    className?: string;
    customPhoneButton?: (onClick: () => void, phoneNumber: string) => ReactNode;
    fetchOnMount?: boolean;
    useHotlineNumber?: boolean;
    buttonSize?: IButtonSizePrimary;
    buttonStyleOverride?: string;
}

const NO_CONTACT_DATA = "BRAK DANYCH KONTAKTOWYCH";

export const ClipPhoneButton = (props: IProps) => {
    const {
        buttonSize,
        buttonStyleOverride,
        fallbackNumber,
        onShowPhoneNumber,
        onClickPhoneNumber,
        text = "Pokaż numer",
        propertyId,
        className,
        customPhoneButton,
        fetchOnMount,
        useHotlineNumber
    } = props;
    const {phoneNumber, fetchClipPhoneNumber, isFetching, isUninitialized, isClipPhoneBlocked} = useApplicationPhoneClipNumber(
        fallbackNumber,
        useHotlineNumber
    );

    useEffect(() => {
        if (fetchOnMount && isUninitialized) {
            fetchClipPhoneNumber(propertyId);
            onShowPhoneNumber?.();
        }
    }, [fetchOnMount]);

    const onClick = () => {
        fetchClipPhoneNumber(propertyId);
        onShowPhoneNumber?.();
    };

    const handleClickPhoneNumber = () => {
        onClickPhoneNumber?.();
    };

    if (isFetching) {
        return (
            <div className={className}>
                <Loader size="sm" />
            </div>
        );
    }

    if (phoneNumber) {
        return (
            customPhoneButton?.(handleClickPhoneNumber, phoneNumber) || (
                <PhoneButton phoneNumber={phoneNumber} onClickPhoneNumber={handleClickPhoneNumber} className={className} />
            )
        );
    }

    if ((!isUninitialized && !phoneNumber) || isClipPhoneBlocked) {
        return (
            <Text as="span" variant="headline_6" align="center" color="var(--colors-secondary)" className={className}>
                {NO_CONTACT_DATA}
            </Text>
        );
    }

    return (
        <div className={className}>
            <Button onClick={onClick} iconLeft={PhoneIcon} type="button" variant="outlined_secondary" size={buttonSize} className={buttonStyleOverride}>
                {text}
            </Button>
        </div>
    );
};
